const actions = {
  SCHOOL_CREATE_REQUEST: "SCHOOL_CREATE_REQUEST",
  SCHOOL_CREATE_SUCCESS: "SCHOOL_CREATE_SUCCESS",
  SCHOOL_CREATE_ERROR: "SCHOOL_CREATE_ERROR",

  STUDENT_CREATE_REQUEST: "STUDENT_CREATE_REQUEST",
  STUDENT_CREATE_SUCCESS: "STUDENT_CREATE_SUCCESS",
  STUDENT_CREATE_ERROR: "STUDENT_CREATE_ERROR",

  RESET_ACTIONTYPE: "RESET_ACTIONTYPE",

  createSchool: (url, body) => ({
    type: actions.SCHOOL_CREATE_REQUEST,
    payload: { url, body },
  }),

  createStudent: (url, body) => ({
    type: actions.STUDENT_CREATE_REQUEST,
    payload: { url, body },
  }),


  

  resetActionType: () => ({
    type: actions.RESET_ACTIONTYPE,
  }),
};

export default actions;
